import { fetchChannels, fetchMarketingCampaign, selectChannels, selectChannelsFirstLoad, selectMarketingCampaign } from "@/entities/marketing-campaign"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Select } from "@/shared/ui/select/select"
import { TelegramTextEditor } from "@/shared/ui/telegram-rich-text-editor"
import { PageHeader } from "@/widgets/page-header"
import { useEffect, useMemo, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import TelegramSvg from "@/shared/assets/images/Telegram.svg"
import { marketingCampaignAnnounce } from "@/shared/api/marketing-campaigns"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"

export const MarketingCampaignAnnouncePage = () => {
    const isFirstRender = useRef(true)
    const { id } = useParams()
    const campaign = useAppSelector(selectMarketingCampaign)
    const channelsFirstLoad = useAppSelector(selectChannelsFirstLoad)
    const channels = useAppSelector(selectChannels)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [selectedChannel, setSelectedChannel] = useState<number | null>(null)
    const [markup, setMarkup] = useState<string>('')
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    
    const channelSelectOptions = useMemo(() => channels.map((channel) => ({
        value: channel.telegramId,
        label: channel.name
    })), [channels])

    useEffect(() => {
        if (id !== campaign.id) {
            dispatch(fetchMarketingCampaign(id))
            .unwrap()
            .catch(() => {
                navigate('/404', { replace: true })
            })
        }
    }, [id])

    useEffect(() => {
        if (channelsFirstLoad) {
            dispatch(fetchChannels())
        }
        isFirstRender.current = false
    }, [])

    const onClick = async () => {
        if (!selectedChannel) {
            notify.error("Выберите канал")
            return
        }
        setIsLoading(true)
        await marketingCampaignAnnounce(campaign.id, markup, selectedChannel)
            .then(() => {
                notify.success('Сообщение успешно отправлено')
            })
            .catch((e) => {
                notify.error(getErrorMessage(e.response?.data?.error_id))
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <div className="_page_container">
            <PageHeader title="Маркетинговые кампании" />
            <div className="flexbox">
                <div className={`font-mediumttf gap-4 flex items-center uppercase text-2xl leading-[24px] py-6 px-5 rounded-2xl w-full bg-[#27A7E7] text-white`}>
                    <div className="bg-gradient-to-b fill-white text-white w-[52px] h-[52px] rounded-xl flex items-center justify-center from-[#475361] to-[#1D1D1D]">
                        <TelegramSvg width={32} height={28} />
                    </div>
                    <div>
                        СОЗДАНИЕ РОЗЫГРЫША В TELEGRAM
                    </div>
                </div>
                <div>
                    <Select
                        value={channelSelectOptions.filter((i) => i.value === selectedChannel)}
                        placeholder="Все каналы"
                        onChange={(e) => setSelectedChannel(e)}
                        options={channelSelectOptions}
                    />
                </div>
                <div className="p-6 flex flex-col h-full bg-white rounded-2xl screen:rounded-3xl">
                    <div className="flex w-full">
                        <div className="flex-1 w-full">
                            <TelegramTextEditor
                                onInputChange={setMarkup}
                            />
                        </div>
                    </div>
                    <div className="flex pt-4 gap-3 flex-col border-t border-[#EAECF0]">
                        <button disabled={isLoading} onClick={onClick} className="form_handle_button !w-fit !px-8">
                            Создать пост
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}